import { useTranslation } from 'react-i18next'
import { LanguageMenu } from '@clari/ui'
import { LOCALE_NATIVE_NAMES } from '@clari/i18n'
import { ADMIN_LOCALES, type AdminLocale } from '@/lib/i18n'

/**
 * Admin language switcher — restricted to FR / EN (see lib/i18n.ts).
 *
 * Shares the compact globe <LanguageMenu> from @clari/ui with apps/web; the
 * `locales` prop keeps the operator console to its two locales while the
 * customer app offers nine.
 */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation('common')
  const current = (i18n.resolvedLanguage ?? i18n.language) as AdminLocale

  return (
    <LanguageMenu
      locales={ADMIN_LOCALES}
      current={current}
      nativeNames={LOCALE_NATIVE_NAMES}
      label={t('language.switch_label')}
      onSelect={(locale) => {
        void i18n.changeLanguage(locale)
      }}
    />
  )
}
